module.exports = __webpack_public_path__ + "media/images/steps/png/172-deal-1-08fb7c49d8b43208c308a828ab85842c.png";